import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { PlanDetailsView } from "./planDetailView";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import PagesHeader from "ah_utility/PagesHeader";
import { useGetSteps } from "../../../utils/getSteps";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
import showToast from "../../../services/toast";
import { useGetInformationSteps } from "ah_utility/workflow";
import { useStepNavigation } from "ah_utility/NavigationEngine";
import { plansClearData } from "../../../store/plans/actions";
import { paymentModeClearData } from "../../../store/paymentModes/action";
import { useCompleteStepPlanDetail, useErrorHandling, useLocalStorageData, usePatchQuoteManagement, usePaymentModes, usePaymentModeSelection, usePlanBenefits, useQuoteManagement, useReprintCertificateManagement, } from "./hooks";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
export var PlanDetails = function () {
    var dispatch = useDispatch();
    var pathname = useLocation().pathname;
    var _a = React.useState(""), price = _a[0], setPrice = _a[1];
    var _b = React.useState(""), currencySymbol = _b[0], setCurrencySymbol = _b[1];
    var _c = useState(false), triggerGetPlan = _c[0], setTriggerGetPlan = _c[1];
    var _d = useState(false), triggerPaymentMode = _d[0], setTriggerPaymentMode = _d[1];
    var _e = useState(false), triggerPatchQuote = _e[0], setTriggerPatchQuote = _e[1];
    var _f = useState(false), triggerReprint = _f[0], setTriggerReprint = _f[1];
    var _g = useState(false), quoteResponse = _g[0], setQuoteResponse = _g[1];
    var _h = useState([]), listBenefit = _h[0], setListBenefit = _h[1];
    var _j = useState(false), enableNextBtn = _j[0], setEnableNextBtn = _j[1];
    var steps = useGetSteps();
    var _k = useState(false), showAlert = _k[0], setShowAlert = _k[1];
    var autoClose = React.useState(10000)[0];
    var autoCloseActive = React.useState(false)[0];
    var msgDescription = React.useState("No es posible generar la cotización, por favor contacte con la aseguradora")[0];
    var _l = React.useState(), paymentMode = _l[0], setPaymentMode = _l[1];
    var _m = React.useState(), bodyPatchQuote = _m[0], setBodyPatchQuote = _m[1];
    var _o = React.useState([
        {
            id: "",
            name: "",
            value: "Anual",
        },
    ]), paymentModeList = _o[0], setPaymentModeList = _o[1];
    var _p = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _p[0], setSeeToast = _p[1];
    // Custom Hooks
    var _q = useLocalStorageData(), Quote = _q.Quote, quoteId = _q.quoteId, User = _q.User, Plan = _q.Plan, valuePlanId = _q.valuePlanId, projectId = _q.projectId;
    var _r = useStepNavigation({ currentStepId: pathname }), dataNavigation = _r.navigation, isLastPage = _r.isLastPage;
    var _s = useGetInformationSteps(pathname), instanceId = _s.instanceId, workFlowId = _s.workFlowId, currentStep = _s.currentStep, nextStep = _s.nextStep;
    var actionFlags = findParamInLocalStorage("", "afy-action-flags");
    var flagFound = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.find(function (flag) { return flag.name === "afy-show-details-in-details-plan"; });
    // Si encuentra el flag Y su value es "true", retorna true; caso contrario, retorna false
    var showDetailsPlan = (flagFound === null || flagFound === void 0 ? void 0 : flagFound.value) === "true";
    var _t = usePaymentModeSelection(setBodyPatchQuote, setTriggerPatchQuote), periodPlanName = _t.periodPlanName, paymentModeId = _t.paymentModeId, paymentModeName = _t.paymentModeName, onApplySelected = _t.onApplySelected, setPaymentModeId = _t.setPaymentModeId, setPaymentModeName = _t.setPaymentModeName;
    var _u = usePaymentModes({
        triggerPaymentMode: triggerPaymentMode,
        projectId: projectId || "",
        setPaymentModeList: setPaymentModeList,
        setPaymentMode: setPaymentMode,
        setPaymentModeId: setPaymentModeId,
        setPaymentModeName: setPaymentModeName,
    }), loadingPaymentMode = _u.loadingPaymentMode, errorPaymentMode = _u.errorPaymentMode;
    var _v = usePlanBenefits({
        triggerGetPlan: triggerGetPlan,
        valuePlanId: valuePlanId,
        projectId: projectId || "",
        setTriggerGetPlan: setTriggerGetPlan,
        setListBenefit: setListBenefit,
    }), loadingPlans = _v.loadingPlans, errorPlans = _v.errorPlans;
    var _w = useQuoteManagement({
        quoteId: quoteId || "",
        quoteResponse: quoteResponse,
        paymentModeId: paymentModeId,
        paymentModeName: paymentModeName,
        userId: (User === null || User === void 0 ? void 0 : User.id) || "",
        setBodyPatchQuote: setBodyPatchQuote,
        setTriggerPatchQuote: setTriggerPatchQuote,
        setPrice: setPrice,
        setCurrencySymbol: setCurrencySymbol,
        setShowAlert: setShowAlert,
        setEnableNextBtn: setEnableNextBtn,
        setQuoteResponse: setQuoteResponse,
    }), loadingOneQuote = _w.loadingOneQuote, errorOneQuote = _w.errorOneQuote, callQuoteOne = _w.callQuoteOne;
    var _x = usePatchQuoteManagement({
        triggerPatchQuote: triggerPatchQuote,
        bodyPatchQuote: bodyPatchQuote,
        quoteId: quoteId || "",
        paymentModeId: paymentModeId,
        setTriggerPatchQuote: setTriggerPatchQuote,
        onPatchSuccess: function () {
            if (showDetailsPlan) {
                setQuoteResponse(true);
                callQuoteOne(quoteId || "");
            }
            else {
                setTriggerReprint(true);
            }
        },
    }), loadingPatchQuote = _x.loadingPatchQuote, errorPatchQuote = _x.errorPatchQuote, loadingQuoteAddFields = _x.loadingQuoteAddFields, errorQuoteAddFields = _x.errorQuoteAddFields;
    var _y = useReprintCertificateManagement({
        triggerReprint: triggerReprint,
        quoteId: quoteId || "",
        setTriggerReprint: setTriggerReprint,
        onReprintSuccess: function () {
            setQuoteResponse(true);
            callQuoteOne(quoteId || "");
        },
    }), loadingReprintType = _y.loadingReprintType, errorReprintType = _y.errorReprintType;
    var _z = useCompleteStepPlanDetail({
        workFlowId: workFlowId,
        instanceId: instanceId,
        currentStep: currentStep,
        nextStep: nextStep,
        pathname: pathname,
        nextRoute: "".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.next),
        setSeeToast: setSeeToast,
    }), onClickNext = _z.onClickNext, loadingComplete = _z.loadingComplete, errorComplete = _z.errorComplete;
    useErrorHandling({
        errorQuoteAddFields: errorQuoteAddFields,
        errorPlans: errorPlans,
        errorPaymentMode: errorPaymentMode,
        errorPatchQuote: errorPatchQuote,
        errorOneQuote: errorOneQuote,
        errorComplete: errorComplete,
        errorReprintType: errorReprintType,
        setSeeToast: setSeeToast,
        onClearPlansData: function () { return dispatch(plansClearData()); },
        onClearPaymentModeData: function () { return dispatch(paymentModeClearData()); },
    });
    useEffect(function () {
        setTriggerPaymentMode(true);
        setTriggerGetPlan(true);
        callQuoteOne(quoteId || "");
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(PagesHeader, { titlePage: "Detalle del plan", hideStep: false, steps: steps, completed: isLastPage }), _jsx(AlertLoadingHeader, { loading: loadingPlans ||
                    loadingOneQuote ||
                    loadingQuoteAddFields ||
                    loadingPatchQuote ||
                    loadingComplete ||
                    loadingPaymentMode ||
                    loadingReprintType, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Cargando plan..." }), _jsx(PlanDetailsView, { apap: true, title: "Modalidad de Plan", btnLblNext: "Siguiente", currencyLbl: currencySymbol, defaultSelect: paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.code, periodPlan: periodPlanName, subtitleBenefit: "Coberturas", subtitleLimit: "Límites", titleDetail: "Detalle del plan", price: price, steps: steps, onClickNext: onClickNext, listBen: listBenefit, applySelect: onApplySelected, paymentModeList: paymentModeList, msgDescription: msgDescription, showAlert: showAlert, autoClose: autoClose, autoCloseActive: autoCloseActive, setShowAlert: setShowAlert, showDetail: !showDetailsPlan, 
                // disabledNextButton={false} // Para produccion  utilizar props.enableNextBtn
                enableNextBtn: parseInt(price) <= 0 })] }));
};
